import { Col, Form, Row, Select } from "antd";
import { useCallback, useMemo, useState } from "react";
import USER_ROLES from "../../../../../../types/UserRoles";
import { useGetRole } from "../../../../../../lib/hooks/getRole";
import { useFormattedRoles } from "../../../../hooks/useFormattedRoles";
import { IOption } from "../../../../../../types/Option";
import { RoleTooltip } from "./RoleTooltip";

type RoleSelectorProps = {
  user: any;
  roles: IOption[];
  isDataDisabled: boolean;
};

export const RoleSelector = ({
  user,
  roles,
  isDataDisabled,
}: RoleSelectorProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [role, _, data] = useGetRole();

  const { formattedRoles } = useFormattedRoles(roles, user?.role);

  const [showTooltip, setShowTooltip] = useState(false);

  const isRoleDisabled = useMemo(() => {
    if (user?.role === USER_ROLES.PORTAL_USER) {
      return true;
    }

    if (role === USER_ROLES.SUPER_ADMIN && data.uid === user?.id) {
      return true;
    }

    if (role === USER_ROLES.ADMIN && data.uid === user?.id) {
      return true;
    }

    if ([USER_ROLES.POSTER, USER_ROLES.SETUP].includes(role)) {
      return true;
    }
  }, [user, role, data]);

  const onChange = useCallback(() => setShowTooltip(true), []);

  return (
    <>
      <Col span={16}>
        <Row>
          <Col span={14}>
            <Form.Item name="roleId" className="mb-0">
              <Select
                options={formattedRoles}
                disabled={isRoleDisabled || isDataDisabled}
                onChange={onChange}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      {showTooltip && <RoleTooltip />}
    </>
  );
};
